import { render, staticRenderFns } from "./DiscountAudit.vue?vue&type=template&id=2f5c12ae&scoped=true&"
import script from "./DiscountAudit.vue?vue&type=script&lang=ts&"
export * from "./DiscountAudit.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountAudit.vue?vue&type=style&index=0&id=2f5c12ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c12ae",
  null
  
)

export default component.exports